import { Permisos } from '@/shared/constants/permisos';
import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourEnsuassSolicitudes: TourDefinicion = {
  codigo: 'ensuass-solicitudes',
  titulo: 'Solicitudes ENSUASS',
  descripcion: 'Histórico de solicitudes de descarga de la base ENSUASS.',
  ruta: '/admin/ensuass/solicitudes',
  permisoMenu: Permisos.ENSUASS_SOLICITUDES_MENU,
  pasos: [
    {
      id: 'ensuass-solicitudes:header',
      selector: '[data-testid="ensuass-solicitudes.header"]',
      titulo: 'Solicitudes ENSUASS',
      descripcion:
        'Consulta qué usuarios pidieron descargar la base ENSUASS, cuándo lo hicieron y con qué criterios.',
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'ensuass-solicitudes:tabla',
      selector: '[data-testid="ensuass-solicitudes.tabla"]',
      titulo: 'Listado',
      descripcion:
        'Pantalla de solo lectura. Las solicitudes quedan registradas para auditoría; cada fila muestra el estado del pedido.',
      side: 'top',
      align: 'center',
    },
  ],
};
